import React from 'react';
import { motion } from 'framer-motion';
const pilares = [{
  num: 'PILAR 01',
  icon: '⚡',
  title: 'Resúmenes en 40 minutos',
  desc: 'Lo que antes te llevaba una tarde, ahora lo tenés antes del almuerzo. Subís el PDF, el sistema te devuelve un resumen estructurado listo para repasar.'
}, {
  num: 'PILAR 02',
  icon: '🎯',
  title: 'Simulacro de parcial personalizado',
  desc: 'El sistema arma preguntas tipo parcial basadas en TU material. Estudiás lo que realmente entra, no lo que creés que entra.'
}, {
  num: 'PILAR 03',
  icon: '📋',
  title: 'Plan de estudio en 10 minutos',
  desc: 'Le decís cuántos días tenés y qué temas hay. Te devuelve un cronograma día por día, sin que se te escape nada.'
}, {
  num: 'PILAR 04',
  icon: '💬',
  title: 'TPs y prácticos al toque',
  desc: 'No es trampa. Es tener un asistente que te ayuda a estructurar, investigar y redactar mejor en la mitad del tiempo.'
}];
const checks = ['Prompts probados en parciales reales', 'Flujo paso a paso para cada tarea', 'Adaptado a cualquier carrera', 'Listo para usar desde hoy', 'Actualizaciones de por vida', 'Funciona con ChatGPT gratuito'];
export function QueEsSistema() {
  return <section className="py-[60px] md:py-[80px]" data-id="element-227">
      <div className="max-w-[800px] mx-auto px-5" data-id="element-228">
        <motion.div initial={{
        opacity: 0
      }} whileInView={{
        opacity: 1
      }} viewport={{
        once: true
      }} className="flex flex-col items-center mb-10" data-id="element-229">
          <p className="text-[11px] font-bold tracking-[3px] text-brand-blue uppercase text-center mb-4 bg-brand-blue/10 py-1.5 px-4 rounded-full border border-brand-blue/30" data-id="element-230">
            🏆 SISTEMA IA UNIVERSITARIO™
          </p>
          <h2 className="text-[clamp(24px,4vw,32px)] font-black text-center leading-[1.2] mb-3" data-id="element-231">
            40+ prompts + guías + plantillas
          </h2>
          <p className="text-[16px] text-brand-gray text-center" data-id="element-232">
            El sistema N°1 para estudiantes universitarios argentinos
          </p>
        </motion.div>

        <div className="grid grid-cols-1 sm:grid-cols-2 gap-5 mb-10" data-id="element-233">
          {pilares.map((pilar, i) => <motion.div key={i} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: i * 0.1
        }} className="bg-navy-2 border border-brand-blue-dark rounded-xl py-7 px-6 relative overflow-hidden" data-id="element-234">
              <div className="absolute top-0 left-0 w-[3px] h-full bg-brand-blue" data-id="element-235" />
              <p className="text-[11px] font-extrabold text-brand-blue tracking-[3px] mb-2.5" data-id="element-236">
                {pilar.num}
              </p>
              <div className="text-[28px] mb-2.5" data-id="element-237">{pilar.icon}</div>
              <h3 className="text-[17px] font-extrabold mb-2.5 leading-[1.3]" data-id="element-238">
                {pilar.title}
              </h3>
              <p className="text-sm text-brand-gray leading-[1.65]" data-id="element-239">
                {pilar.desc}
              </p>
            </motion.div>)}
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="bg-navy-3 border border-brand-blue-dark rounded-xl p-6 md:p-8" data-id="element-240">
          <h3 className="text-[15px] font-bold text-white mb-5 text-center uppercase tracking-[1px]" data-id="element-241">
            Cada módulo incluye:
          </h3>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-y-4 gap-x-6" data-id="element-242">
            {checks.map((check, i) => <div key={i} className="flex items-center gap-3" data-id="element-243">
                <span className="text-brand-success text-[16px]" data-id="element-244">✅</span>
                <span className="text-[14px] text-brand-gray font-medium" data-id="element-245">
                  {check}
                </span>
              </div>)}
          </div>
        </motion.div>
      </div>
    </section>;
}